/* eslint-disable no-param-reassign */

export const calculateRmgDimensions = () => {
  const w = window.innerWidth;
  const h = window.innerHeight;
  const availableArea = w * h / 3;
  // we use the formula Area = 352x * 230x to take into consideration the ratio
  const solveForX = Math.sqrt(availableArea / (352 * 230));
  return ({
    width: solveForX * 352,
    height: solveForX * 230,
    footer: solveForX * (230 - 198),
  });
};

export const createRMGPlayerScript = (script, currentStream) => {
  script.src = 'https://player.performgroup.com/csb.js';
  script.setAttribute('async', true);
  script.setAttribute('id', 'scfPlayer');

  script.setAttribute('data-uuid', currentStream.rmg.fixtureUuid);
  script.setAttribute('data-outletkey', currentStream.rmg.outletAuthKey);
  script.setAttribute('data-apptype', 'csb');
  script.setAttribute('data-env', 'betting');
  script.setAttribute('data-streamuuid', currentStream.rmg.livestreamUuid);
  script.setAttribute('data-streamuser', `${currentStream.accountId}`);
  script.setAttribute('data-oauthtoken', currentStream.token);
  script.setAttribute('data-rmg', 'true');
  script.setAttribute('data-width', '352px');
  script.setAttribute('data-height', '230px');
  script.setAttribute('data-cssdiff', `${window.location.origin}/3rd-party-assets/rmg.css`);
  script.setAttribute('data-defaultview', 'video');
};

export const toggleCinemaMode = (cinemaMode, container, styleClass) => {
  const actionButtonsContainer = document.getElementById('rmgControls');
  if (cinemaMode && container) {
    const dimensions = calculateRmgDimensions();
    const clientRect = container.getBoundingClientRect();
    // we also want to move the control buttons
    const buttonsClientRect = actionButtonsContainer.getBoundingClientRect();
    // this is the x space that the player should have on the left and right side
    const spaceX = (window.innerWidth - dimensions.width) / 2;
    // this is the y space that the player should have above and below
    const spaceY = (window.innerHeight - dimensions.height) / 2;
    // calculating variations aka Δ
    const deltaX = spaceX - clientRect.x;
    // deltaY is different because we are hiding the footer
    const deltaY = spaceY + (dimensions.footer / 2) - clientRect.y;
    container.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    container.classList.add(`${styleClass}`);
    container.style.width = `${dimensions.width}px`;
    container.style.height = `${dimensions.height}px`;
    container.style.minHeight = `${dimensions.height}px`;
    // this calculation is done taking the original spacial information and
    // deducing the new coordinates using the space and the player dimensions
    actionButtonsContainer.style.transform = `translate(${-(buttonsClientRect.x - spaceX - dimensions.width + buttonsClientRect.width + 8)}px, ${-(buttonsClientRect.y - (dimensions.footer / 2) - 8 - spaceY)}px)`;
    // to keep the button as top layer
    actionButtonsContainer.style.zIndex = 10;
  } else if (container) {
    // resetting to original values or empty
    container.classList.remove(`${styleClass}`);
    container.style.width = '';
    container.style.height = '';
    container.style.minHeight = '';
    container.style.transform = '';
    actionButtonsContainer.style.transform = '';
    actionButtonsContainer.style.zIndex = '';
  }
};

export default calculateRmgDimensions;
